export const defaultItemTemplate = (baseDate: Date = new Date()) => `{
  "serialNumber": "SER-ITEM-0001",
  "batchNumber": "BATCH-2026-04",
  "productionDate": "${new Date(baseDate.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString()}",
  "productExpiryDate": "${new Date(baseDate.getTime() + 180 * 24 * 60 * 60 * 1000).toISOString()}",
  "productionCountry": {
    "countryCode": "FR",
    "countryName": "France"
  },
  "quantity": {
    "value": 100,
    "unit": "PCE"
  },
  "weight": {
    "value": 45,
    "unit": "KGM"
  },
  "products": [
    {
      "uri": "urn:bol:product:prd-001"
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "SELLER_ID",
      "reference": "ITEM-2026-001"
    }
  ]
}`;
